import { render, staticRenderFns } from "./dropdown.html?vue&type=template&id=a48df9f4&scoped=true&external"
import script from "./dropdown.js?vue&type=script&lang=js&external"
export * from "./dropdown.js?vue&type=script&lang=js&external"
import style0 from "./dropdown.scss?vue&type=style&index=0&id=a48df9f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48df9f4",
  null
  
)

export default component.exports